<template>
  <RevCard
    class="!bg-surface-default-mid mb-32 flex cursor-pointer flex-row items-center"
    hoverable
    @click="openDaModal"
  >
    <img
      alt=""
      class="rounded-l-lg size-[92px]"
      :src="toPublicPath(illustration)"
    />
    <span class="body-2 my-12 line-clamp-3 flex-1 text-ellipsis px-16">
      {{ i18n(label) }}
    </span>
    <IconChevronRight class="mx-24" />
  </RevCard>
</template>

<script lang="ts" setup>
import { toPublicPath } from '#imports'

import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

const props = defineProps<{
  modalName: string
  illustration: string
  label: I18nDefinition
}>()

const i18n = useI18n()

function openDaModal() {
  openModal(props.modalName)
}
</script>
